import { gql } from '@apollo/client';

import { ResponsiveImageFragment } from 'approot/shared/graphql/responsive-images/responsive-images.graphql';

export const DictionaryBookItemFragment = gql`
  fragment DictionaryBookItemFragment on DictionaryBookItem {
    id
    word
    lexical
    sourceDefinition
    aiDefinitions {
      wordsTranslation {
        word
        language
      }
      definitions {
        year
        definition
        language
      }
      examples {
        language
        exampleId
        example
        image {
          alt
          ...ResponsiveImageFragment
        }
      }
    }
  }
  ${ResponsiveImageFragment}
`;

export const FIND_IN_DICTIONARY_BOOK = gql`
  query FindInDictionaryBook($input: FindInDictionaryBookInput!) {
    findInDictionaryBook(input: $input) {
      id
      word
      lexical
      sourceDefinition
      aiDefinitions {
        definitions {
          year
          definition
        }
      }
      approved
      popularity
      data {
        count
      }
    }
  }
`;

export const ASK_DICTIONARY_FOR_RAW_DEFINITIONS = gql`
  query AskDictionaryForRawDefinitions(
    $input: AskDictionaryForRawDefinitionsInput!
  ) {
    askDictionaryForRawDefinitions(input: $input) {
      definitions {
        word
        definition
        lexical
      }
    }
  }
`;

export const ASK_DICTIONARY_WITH_DEFINITION = gql`
  query AskDictionaryWithDefinition($input: AskDictionaryWithDefinitionInput!) {
    askDictionaryWithDefinition(input: $input) {
      completionId
      word
      spelling
      lexical
      examples {
        example
        exampleId
        imageId
        image {
          alt
          ...ResponsiveImageFragment
        }
      }
      definitions {
        year
        definition
      }
    }
  }
  ${ResponsiveImageFragment}
`;

export const GENERATE_IMAGE = gql`
  query GenerateImage($input: GenerateImageInput!) {
    generateImage(input: $input) {
      url
      key
    }
  }
`;

export const GENERATE_IMAGE_ALT_TEXT = gql`
  query GenerateImageAltText($input: GenerateImageAltTextInput!) {
    generateImageAltText(input: $input) {
      altText
    }
  }
`;

export const SAVE_TO_DICTIONARY_BOOK = gql`
  mutation SaveToDictionaryBook($input: SaveDictionaryBookInput!) {
    saveToDictionaryBook(input: $input) {
      ...DictionaryBookItemFragment
    }
  }
  ${DictionaryBookItemFragment}
`;

export const DELETE_FROM_DICTIONARY = gql`
  mutation DeleteFromDictionary($input: DeleteFromDictionaryInput!) {
    deleteFromDictionary(input: $input)
  }
`;

export const TRANSLATE_TO = gql`
  query TranslateTo($input: TranslateToInput!) {
    translateTo(input: $input) {
      translations {
        translationId
        translation
      }
    }
  }
`;
